(function () {

  // ─── Config ────────────────────────────────────────────────────────────────
  const PROXY_URL = 'https://mm-ingredient-proxy.vercel.app/api/ingredient';
  const INGREDIENTS_SELECTOR = '.collapsible-content__inner.rte';
  const INGREDIENTS_TITLE_MATCH = 'ingredient';

  // ─── Styles ────────────────────────────────────────────────────────────────
  const CSS = `
    .mm-ing-wrap {
      display: flex;
      flex-direction: column;
      gap: 8px;
      align-items: flex-start;
    }

    .mm-saponified-card {
      border-left: 3px solid #1D9E75;
      border-top: 0.5px solid #e4e1d9;
      border-right: 0.5px solid #e4e1d9;
      border-bottom: 0.5px solid #e4e1d9;
      border-radius: 0 10px 10px 0;
      background: #fff;
      overflow: hidden;
    }

    .mm-saponified-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 11px 14px;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
    }
    .mm-saponified-header:active { background: #f7fbf9; }

    .mm-saponified-tag {
      display: inline-block;
      background: #eef7f3;
      color: #0F6E56;
      font-size: 10px;
      padding: 2px 8px;
      border-radius: 10px;
      font-weight: 600;
      letter-spacing: 0.03em;
      margin-bottom: 5px;
    }

    .mm-saponified-title {
      font-size: 13px;
      font-weight: 600;
      color: #1a1a1a;
      margin: 0;
    }

    .mm-saponified-sub {
      font-size: 11px;
      color: #aaa;
      margin: 2px 0 0;
    }

    .mm-saponified-chevron {
      color: #ccc;
      font-size: 18px;
      line-height: 1;
      flex-shrink: 0;
      margin-left: 8px;
    }

    .mm-saponified-children {
      border-top: 0.5px solid #e8f5f0;
      background: #f4fbf8;
      padding: 10px 14px 12px;
      display: flex;
      flex-wrap: wrap;
      gap: 7px;
    }

    .mm-child-pill {
      display: inline-flex;
      align-items: center;
      gap: 5px;
      background: #fff;
      border: 0.5px solid #9FE1CB;
      border-radius: 20px;
      padding: 7px 13px 7px 9px;
      font-size: 12px;
      color: #085041;
      cursor: pointer;
      font-weight: 500;
      -webkit-tap-highlight-color: transparent;
      transition: background 0.15s;
    }
    .mm-child-pill:hover { background: #e8f5f0; }
    .mm-child-pill:active { background: #d8f0e8; }

    .mm-child-dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #1D9E75;
      flex-shrink: 0;
    }

    .mm-standalone-pills {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }

    .mm-standalone-pill {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      background: #fff;
      border: 0.5px solid #d4d0c8;
      border-radius: 20px;
      padding: 8px 15px 8px 10px;
      font-size: 12px;
      color: #2a2a2a;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      transition: border-color 0.15s, background 0.15s;
    }
    .mm-standalone-pill:hover { border-color: #1D9E75; background: #f7fbf9; }
    .mm-standalone-pill:active { background: #eef7f3; }

    .mm-standalone-dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #aaa;
      flex-shrink: 0;
    }

    .mm-popup-overlay {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.45);
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
      animation: mmFadeIn 0.18s ease;
    }
    @keyframes mmFadeIn { from { opacity: 0; } to { opacity: 1; } }

    .mm-popup {
      background: #fff;
      border-radius: 12px;
      padding: 1.5rem;
      max-width: 420px;
      width: 100%;
      box-shadow: 0 8px 40px rgba(0,0,0,0.18);
      animation: mmSlideUp 0.2s ease;
      position: relative;
    }
    @keyframes mmSlideUp {
      from { transform: translateY(12px); opacity: 0; }
      to   { transform: translateY(0);    opacity: 1; }
    }

    .mm-popup__close {
      position: absolute;
      top: 1rem;
      right: 1rem;
      background: none;
      border: none;
      cursor: pointer;
      font-size: 22px;
      line-height: 1;
      color: #888;
      padding: 0;
    }
    .mm-popup__close:hover { color: #333; }

    .mm-popup__name {
      font-size: 18px;
      font-weight: 600;
      margin: 0 0 0.35rem;
      padding-right: 2rem;
      color: #1a1a1a;
    }

    .mm-popup__badge {
      display: inline-block;
      font-size: 11px;
      padding: 3px 10px;
      border-radius: 20px;
      background: #e1f5ee;
      color: #0f6e56;
      margin-bottom: 1rem;
      font-weight: 500;
      letter-spacing: 0.02em;
    }

    .mm-popup__body {
      font-size: 14px;
      line-height: 1.75;
      color: #444;
    }

    .mm-popup__loading {
      display: flex;
      gap: 5px;
      align-items: center;
      height: 24px;
    }
    .mm-dot {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #1d9e75;
      animation: mmPulse 1.2s infinite;
    }
    .mm-dot:nth-child(2) { animation-delay: 0.2s; }
    .mm-dot:nth-child(3) { animation-delay: 0.4s; }
    @keyframes mmPulse { 0%,80%,100%{ opacity:0.2; } 40%{ opacity:1; } }

    .mm-popup__error { color: #c0392b; font-size: 13px; }

    .mm-popup__footer {
      margin-top: 1.25rem;
      padding-top: 0.85rem;
      border-top: 1px solid #eee;
      font-size: 11px;
      color: #aaa;
      display: flex;
      align-items: center;
      gap: 6px;
    }
  `;

  // ─── Ingredient parser ─────────────────────────────────────────────────────

  const NON_OIL_KEYWORDS = [
    'fragrance', 'mica', 'extract', 'powder',
    'wax', 'clay', 'colorant', 'oxide', 'water', 'aqua',
    'alcohol', 'glycerin', 'vitamin', 'flavor', 'essential',
    'calendula', 'dried', 'ground', 'matcha',
    'aloe', 'beeswax', 'candelilla', 'optiphen', 'polysorbate',
    'bentonite', 'kaolin', 'arrowroot', 'citric', 'sodium', 'titanium'
  ];

  function looksLikeOil(str) {
    const lower = str.toLowerCase();
    if (NON_OIL_KEYWORDS.some(k => lower.includes(k))) return false;
    if (/\boats\b|\boatmeal\b/i.test(lower)) return false;
    if (lower.includes('oil')) return true;
    if (lower.includes('butter')) return true;
    return false;
  }

 function smartSplit(str) {
    const eoPlaceholders = [];

    const protected_str = str.replace(/essential oils\s+of\s+(.+?)(?=,\s*(?:[^,]*?\b(?:fragrance|calendula|chamomile buds|dried|ground|matcha|aloe|beeswax|candelilla|vitamin|glycerin|mica|titanium|optiphen|polysorbate|bentonite|kaolin|arrowroot|baking|citric|sodium)\b)|$)/gi, match => {
      eoPlaceholders.push(match);
      return `__EO_${eoPlaceholders.length - 1}__`;
    });

    const parts = protected_str
      .split(/,\s*|\s+and\s+/i)
      .map(s => s.replace(/^(and\s+)/i, '').trim())
      .filter(Boolean)
      .map(s => s.replace(/__EO_(\d+)__/g, (_, i) => eoPlaceholders[parseInt(i)]));

    return parts;
  }

function expandEssentialOils(parts) {
    const result = [];
    parts.forEach(part => {
      const eoMatch = part.match(/^essential oils\s+of\s+(.+)/i);
      if (eoMatch) {
        const inner = eoMatch[1].trim();

        const commaAndEndMatch = inner.match(/^(.*),\s*and\s+([^,]+)$/i);
        const bareAndEndMatch = inner.match(/^(.*)\s+and\s+([^,\s][^,]*)$/i);

        let eoSection, remainder;

        if (commaAndEndMatch) {
          eoSection = commaAndEndMatch[1];
          remainder = commaAndEndMatch[2].trim();
        } else if (bareAndEndMatch) {
          const potentialRemainder = bareAndEndMatch[2].trim();
          // Only treat as standalone if it matches a known non-scent keyword
          if (NON_OIL_KEYWORDS.some(k => potentialRemainder.toLowerCase().includes(k))) {
            eoSection = bareAndEndMatch[1];
            remainder = potentialRemainder;
          } else {
            // It's just another scent — keep it in the essential oils group
            eoSection = inner;
            remainder = null;
          }
        } else {
          eoSection = inner;
          remainder = null;
        }

        // If remainder looks like it contains a fragrance/non-scent ingredient,
        // check if eoSection itself ends with "and X" that should also be standalone
        if (remainder && NON_OIL_KEYWORDS.some(k => remainder.toLowerCase().includes(k))) {
          // remainder is confirmed standalone — but also recheck eoSection's last "and"
          const eoAndMatch = eoSection.match(/^(.*),\s*([^,]+)$/i);
          if (eoAndMatch) {
            const lastEoPart = eoAndMatch[2].trim();
            if (NON_OIL_KEYWORDS.some(k => lastEoPart.toLowerCase().includes(k))) {
              result.push(capitalize(lastEoPart));
              eoSection = eoAndMatch[1];
            }
          }
        }

        const scents = eoSection.split(/,\s*|\s+and\s+/i).map(s => s.trim()).filter(Boolean);
        scents.forEach(scent => {
          result.push('Essential oil of ' + scent.toLowerCase());
        });

        if (remainder) result.push(capitalize(remainder));
      } else {
        result.push(part);
      }
    });
    return result;
  }

  function parseIngredients(text) {
    const cleaned = text.replace(/\.$/, '').trim();
    const saponifiedMatch = cleaned.match(/(?:^|,\s*)saponified\s+(.+)/i);

    if (!saponifiedMatch) {
      return { saponified: [], standalone: expandEssentialOils(smartSplit(cleaned)) };
    }

    // Everything before "Saponified" is a standalone ingredient
    const saponifiedIdx = cleaned.search(/(?:^|(?<=,\s*))saponified\s+/i);
    const beforeSaponified = saponifiedIdx > 0
      ? smartSplit(cleaned.slice(0, saponifiedIdx).replace(/,\s*$/, ''))
      : [];

    const allParts = smartSplit(saponifiedMatch[1]);
    const saponified = [];
    const standalone = [];
    let saponifiedDone = false;

    allParts.forEach(part => {
      if (!saponifiedDone && looksLikeOil(part)) {
        saponified.push(friendlyOilName(part));
      } else {
        saponifiedDone = true;
        standalone.push(part);
      }
    });

    return {
      saponified,
      standalone: [...expandEssentialOils(beforeSaponified), ...expandEssentialOils(standalone)]
    };
  }

  function friendlyOilName(str) {
    const cleaned = str.replace(/^[&\s]+/, '').trim();
    const lower = cleaned.toLowerCase();
    const oilIdx = lower.lastIndexOf('oil');
    if (oilIdx !== -1) {
      const before = cleaned.slice(0, oilIdx).trim();
      return capitalize(before) + ' oil';
    }
    const butterIdx = lower.lastIndexOf('butter');
    if (butterIdx !== -1) {
      const before = cleaned.slice(0, butterIdx).trim();
      return capitalize(before) + ' butter';
    }
    return capitalize(cleaned);
  }

  // ─── DOM builder ──────────────────────────────────────────────────────────

  function injectStyles() {
    if (document.getElementById('mm-ing-styles')) return;
    const style = document.createElement('style');
    style.id = 'mm-ing-styles';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function findIngredientContainers() {
    const results = [];
    document.querySelectorAll('.collapsibles-wrapper').forEach(wrapper => {
      const trigger = wrapper.querySelector('.collapsible-trigger');
      if (trigger && trigger.textContent.toLowerCase().includes(INGREDIENTS_TITLE_MATCH)) {
        const content = wrapper.querySelector(INGREDIENTS_SELECTOR);
        if (content) results.push(content);
      }
    });
    return results;
  }

  function renderIngredients(container) {
    if (!container || container.dataset.mmLinked) return;
    const raw = container.textContent.trim();
    if (!raw) return;

    const { saponified, standalone } = parseIngredients(raw);
    if (saponified.length === 0 && standalone.length === 0) return;

    container.dataset.mmLinked = '1';
    container.innerHTML = '';

    const wrap = document.createElement('div');
    wrap.className = 'mm-ing-wrap';

    if (saponified.length > 0) {
      const blendQuery = 'Saponified ' + saponified.map(o => o.toLowerCase()).join(', ');

      const card = document.createElement('div');
      card.className = 'mm-saponified-card';

      const header = document.createElement('div');
      header.className = 'mm-saponified-header';
      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');
      header.setAttribute('aria-label', 'Learn about saponification and these oils');
      header.innerHTML = `
        <div>
          <div class="mm-saponified-tag">Saponified</div>
          <div class="mm-saponified-title">${saponified.join(', ')}</div>
          <div class="mm-saponified-sub">Tap to learn about saponification</div>
        </div>
        <span class="mm-saponified-chevron">›</span>`;
      header.addEventListener('click', () => openPopup(blendQuery, true));
      header.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') openPopup(blendQuery, true);
      });

      const children = document.createElement('div');
      children.className = 'mm-saponified-children';

      saponified.forEach(oil => {
        const pill = document.createElement('button');
        pill.className = 'mm-child-pill';
        pill.innerHTML = `<span class="mm-child-dot"></span>${oil}`;
        pill.setAttribute('aria-label', `Learn more about ${oil}`);
        pill.addEventListener('click', e => { e.stopPropagation(); openPopup(oil); });
        children.appendChild(pill);
      });

      card.appendChild(header);
      card.appendChild(children);
      wrap.appendChild(card);
    }

    if (standalone.length > 0) {
      const pillWrap = document.createElement('div');
      pillWrap.className = 'mm-standalone-pills';

      standalone.forEach(ing => {
        const pill = document.createElement('button');
        pill.className = 'mm-standalone-pill';
        pill.innerHTML = `<span class="mm-standalone-dot"></span>${ing}`;
        pill.setAttribute('aria-label', `Learn more about ${ing}`);
        pill.addEventListener('click', () => openPopup(ing));
        pillWrap.appendChild(pill);
      });

      wrap.appendChild(pillWrap);
    }

    container.appendChild(wrap);
  }

  // ─── Popup ─────────────────────────────────────────────────────────────────

  let activeOverlay = null;

  function buildPopupShell() {
    const overlay = document.createElement('div');
    overlay.className = 'mm-popup-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.addEventListener('click', e => { if (e.target === overlay) closePopup(); });

    const onKeyDown = e => { if (e.key === 'Escape') closePopup(); };
    document.addEventListener('keydown', onKeyDown);
    overlay._cleanup = () => document.removeEventListener('keydown', onKeyDown);

    const popup = document.createElement('div');
    popup.className = 'mm-popup';
    overlay.appendChild(popup);
    return { overlay, popup };
  }

  function renderLoading(popup, displayName) {
    popup.innerHTML = `
      <button class="mm-popup__close" aria-label="Close">&times;</button>
      <h2 class="mm-popup__name">${capitalize(displayName)}</h2>
      <div class="mm-popup__badge">Looking up ingredient…</div>
      <div class="mm-popup__body">
        <div class="mm-popup__loading">
          <div class="mm-dot"></div>
          <div class="mm-dot"></div>
          <div class="mm-dot"></div>
        </div>
      </div>`;
    popup.querySelector('.mm-popup__close').addEventListener('click', closePopup);
  }

  function renderContent(popup, displayName, data) {
    popup.innerHTML = `
      <button class="mm-popup__close" aria-label="Close">&times;</button>
      <h2 class="mm-popup__name">${capitalize(displayName)}</h2>
      <div class="mm-popup__badge">${escapeHtml(data.badge || 'Ingredient')}</div>
      <div class="mm-popup__body">${escapeHtml(data.explanation)}</div>
      <div class="mm-popup__footer">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <circle cx="6" cy="6" r="5.5" stroke="#ccc"/>
          <path d="M6 5v4M6 3.5v.5" stroke="#ccc" stroke-linecap="round"/>
        </svg>
        For educational purposes only. Always consult a dermatologist for skin concerns.
      </div>`;
    popup.querySelector('.mm-popup__close').addEventListener('click', closePopup);
  }

  function renderError(popup, displayName) {
    popup.innerHTML = `
      <button class="mm-popup__close" aria-label="Close">&times;</button>
      <h2 class="mm-popup__name">${capitalize(displayName)}</h2>
      <div class="mm-popup__body mm-popup__error">
        Sorry, we couldn't load information for this ingredient. Please try again.
      </div>`;
    popup.querySelector('.mm-popup__close').addEventListener('click', closePopup);
  }

  async function openPopup(name, isSaponifiedGroup) {
    closePopup();
    const { overlay, popup } = buildPopupShell();
    const displayName = isSaponifiedGroup ? 'Saponified oils' : name;
    renderLoading(popup, displayName);
    document.body.appendChild(overlay);
    activeOverlay = overlay;

    try {
      const data = await fetchIngredientInfo(name, isSaponifiedGroup);
      if (activeOverlay === overlay) renderContent(popup, displayName, data);
    } catch (err) {
      console.warn('[MM Ingredients]', err);
      if (activeOverlay === overlay) renderError(popup, displayName);
    }
  }

  function closePopup() {
    if (activeOverlay) {
      if (activeOverlay._cleanup) activeOverlay._cleanup();
      activeOverlay.remove();
      activeOverlay = null;
    }
  }

  // ─── API ───────────────────────────────────────────────────────────────────

  const cache = {};

  async function fetchIngredientInfo(name, isSaponifiedGroup) {
    const key = name.toLowerCase();
    if (cache[key]) return cache[key];

    const modalTitle = document.querySelector('.modal--is-active .product-single__title');
    const pageTitle = document.querySelector('.product-title, .product__title, h1.title, h1');
    const productName = (modalTitle || pageTitle)?.textContent?.trim() || '';

    const response = await fetch(PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ingredient: name,
        context: 'handmade soap and skincare',
        productName: productName,
        isSaponifiedGroup: isSaponifiedGroup || false
      })
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const data = await response.json();
    cache[key] = data;
    return data;
  }

  // ─── Init ──────────────────────────────────────────────────────────────────

  function init() {
    injectStyles();
    findIngredientContainers().forEach(renderIngredients);

    const observer = new MutationObserver(() => {
      findIngredientContainers().forEach(renderIngredients);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ─── Utils ─────────────────────────────────────────────────────────────────

  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

})();